<li class="nav-item">
    <a href="javascript:void(0)" class="nav-link" (click)="onClick()">
        <i class="show-icon" [ngClass]="iconClass"></i> <span class="hide-text">
            <ng-content></ng-content>
        </span>
    </a>
</li>